import axios from 'axios';

export const url = (env) => {
  if (env === 'development') {
    return process.env.REACT_APP_DEV_URL;
  }
  if (env === 'production') {
    return process.env.REACT_APP_BACKEND_URL;
  }
};

const axiosInstance = axios.create({
  baseURL: url(process.env.NODE_ENV), // Backend URL
  withCredentials: true // Allow cookies to be sent with requests
});

// Add Authorization header if token is available (fallback for cross-origin issues)
axiosInstance.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token') || sessionStorage.getItem('token');
    if (token) {
      try {
        // Remove JSON quotes if token is stored as JSON string
        const cleanToken = typeof token === 'string' && token.startsWith('"') ? JSON.parse(token) : token;
        config.headers.Authorization = `Bearer ${cleanToken}`;
      } catch (e) {
        // Token might not be JSON, use as-is
        config.headers.Authorization = `Bearer ${token}`;
      }
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Handle 401 errors by clearing token and redirecting to login
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Clear stored token on auth failure
      localStorage.removeItem('token');
      sessionStorage.removeItem('token');
      // Optionally redirect to login
      // window.location.href = '/auth/login';
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
